import React, { useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography, FormControlLabel, Checkbox, Link, InputAdornment, IconButton, useMediaQuery, useTheme, Alert, LinearProgress } from '@mui/material';
import { Icon } from '@iconify/react';
import { OPENREMIT_LOGO_ALT, OPENREMIT_LOGO_SRC } from '../utils/brand';
interface LoginProps {
  onLogin: (username: string, password: string) => boolean;
}
const Login: React.FC<LoginProps> = ({
  onLogin
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password');
      return;
    }
    setLoading(true);
    // Simulate network request
    setTimeout(() => {
      const success = onLogin(username, password);
      if (!success) {
        setError('Invalid username or password');
        setLoading(false);
      }
    }, 800);
  };
  return <Box sx={{
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative'
  }} data-id="element-3761" data-mp="2wgf44bs9v2mz">
      {!isMobile && <Box sx={{
      flex: 1,
      backgroundColor: '#FFFFFF',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 4,
      overflow: 'hidden',
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #22D3EE 0%, #6366F1 100%)',
        zIndex: 10
      }
    }} data-id="element-3762" data-mp="3a9mw44k9m057">
          <Box component="img" src={OPENREMIT_LOGO_SRC} alt={OPENREMIT_LOGO_ALT} sx={{
        height: 60,
        mb: 3,
        filter: 'drop-shadow(0 4px 6px rgba(34, 211, 238, 0.2))',
        transition: 'all 300ms ease',
        '&:hover': {
          transform: 'scale(1.05) translateY(-2px)',
          filter: 'drop-shadow(0 8px 16px rgba(34, 211, 238, 0.3))'
        }
      }} data-id="element-3763" data-mp="2ehkzr1iqaate" />
          <Typography variant="h4" component="h1" fontWeight="700" gutterBottom color="text.primary" sx={{
        background: 'linear-gradient(135deg, #22D3EE 0%, #6366F1 100%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        mb: 2
      }} data-id="element-3764" data-mp="328yq51xbjwbq">
            Simplify Cross-Border Payments
          </Typography>
          <Typography variant="body1" sx={{
        maxWidth: 450,
        textAlign: 'center',
        color: 'text.secondary',
        lineHeight: 1.6
      }} data-id="element-3765" data-mp="10hq5ptlkd57t">
            Manage remittances, track transactions, and ensure compliance all
            from one powerful dashboard.
          </Typography>
          <Box component="img" src="https://img.freepik.com/free-vector/global-money-transfer-abstract-concept-illustration_335657-3893.jpg" alt="Global Payments Illustration" sx={{
        width: '70%',
        maxWidth: 400,
        mt: 4,
        filter: 'drop-shadow(0 12px 24px rgba(99, 102, 241, 0.2))',
        transition: 'all 500ms ease',
        animation: 'float 6s ease-in-out infinite',
        '@keyframes float': {
          '0%': {
            transform: 'translateY(0px)'
          },
          '50%': {
            transform: 'translateY(-10px)'
          },
          '100%': {
            transform: 'translateY(0px)'
          }
        }
      }} data-id="element-3766" data-mp="1j9j27xzud8ka" />
        </Box>}
      <Box sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 2,
      background: 'linear-gradient(135deg, #22D3EE 0%, #6366F1 100%)',
      overflow: 'auto',
      position: 'relative'
    }} data-id="element-3767" data-mp="1ht3jiz127kwz">
        <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.1,
        backgroundImage: 'url("https://www.transparenttextures.com/patterns/cubes.png")',
        backgroundSize: '300px',
        animation: 'bgMove 30s linear infinite',
        '@keyframes bgMove': {
          from: {
            backgroundPosition: '0 0'
          },
          to: {
            backgroundPosition: '300px 300px'
          }
        }
      }} data-id="element-3768" data-mp="20p3fekx5r8lu" />
        <Card sx={{
        maxWidth: 400,
        width: '100%',
        py: 1.5,
        position: 'relative',
        zIndex: 2,
        overflow: 'visible',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 12px 32px rgba(2,6,23,0.15)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: -2,
          left: -2,
          right: -2,
          bottom: -2,
          background: 'linear-gradient(135deg, #22D3EE 0%, #6366F1 100%)',
          borderRadius: '18px',
          zIndex: -1,
          opacity: 0.4,
          filter: 'blur(10px)',
          transition: 'all 300ms ease'
        },
        '&:hover::before': {
          opacity: 0.6,
          filter: 'blur(15px)'
        }
      }} elevation={6} data-id="element-3769" data-mp="miypqtqfftap">
          {loading && <LinearProgress sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16
        }} data-id="element-3770" data-mp="lrqpno7gpmw5" />}
          <CardContent sx={{
          padding: {
            xs: 2.5,
            sm: 3.5
          },
          backgroundColor: '#FFFFFF'
        }} data-id="element-3771" data-mp="3ua6g29c5ppyl">
            <Box sx={{
            textAlign: 'center',
            mb: 3
          }} data-id="element-3772" data-mp="6xvkotafghq8">
              {isMobile && <Box component="img" src={OPENREMIT_LOGO_SRC} alt={OPENREMIT_LOGO_ALT} sx={{
              height: 50,
              mb: 1.5,
              filter: 'drop-shadow(0 4px 6px rgba(34, 211, 238, 0.2))'
            }} data-id="element-3773" data-mp="3akvysqwriwyd" />}
              <Typography variant="h5" component="h1" fontWeight="700" color="text.primary" sx={{
              background: 'linear-gradient(135deg, #22D3EE 0%, #6366F1 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }} data-id="element-3774" data-mp="2u3azyyz4m6ig">
                Welcome to OpenRemit Backoffice
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={0.5} data-id="element-3775" data-mp="21dc9r09743c7">
                Sign in to access your dashboard
              </Typography>
              <Box sx={{
              mt: 1.5,
              p: 1.5,
              bgcolor: 'rgba(79, 70, 229, 0.05)',
              borderRadius: 2,
              border: '1px dashed rgba(79, 70, 229, 0.2)'
            }} data-id="element-3776" data-mp="1wfstjusxtghm">
                <Typography variant="caption" color="text.secondary" display="block" fontWeight={600} sx={{
                mb: 0.5
              }} data-id="element-3777" data-mp="3b97lsd8pwlvz">
                  Demo Credentials
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block" fontFamily="monospace" data-id="element-3778" data-mp="36ch8tys7m6es">
                  Maker: admin / test@1234
                </Typography>
                <Typography variant="caption" color="text.secondary" display="block" fontFamily="monospace" data-id="element-3779" data-mp="2ilk4p86node3">
                  Checker: checker / test@1234
                </Typography>
              </Box>
            </Box>
            {error && <Alert severity="error" sx={{
            mb: 1.5,
            fontSize: '0.8rem',
            borderRadius: 2,
            animation: 'shake 0.5s ease-in-out',
            '@keyframes shake': {
              '0%, 100%': {
                transform: 'translateX(0)'
              },
              '10%, 30%, 50%, 70%, 90%': {
                transform: 'translateX(-5px)'
              },
              '20%, 40%, 60%, 80%': {
                transform: 'translateX(5px)'
              }
            }
          }} onClose={() => setError('')} data-id="element-3780" data-mp="2dwj3255b3nu3">
                {error}
              </Alert>}
            <Box component="form" onSubmit={handleSubmit} data-id="element-3781" data-mp="31k0prm9prvq7">
              <TextField label="Username" variant="outlined" fullWidth margin="normal" value={username} onChange={e => setUsername(e.target.value)} required size="small" sx={{
              mb: 1.5,
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#FFFFFF',
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#4F46E5',
                  borderWidth: 1.5
                }
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#4F46E5'
              }
            }} disabled={loading} data-id="element-3782" data-mp="p45silqzex63" />
              <TextField label="Password" type={showPassword ? 'text' : 'password'} variant="outlined" fullWidth margin="normal" value={password} onChange={e => setPassword(e.target.value)} required size="small" InputProps={{
              endAdornment: <InputAdornment position="end" data-id="element-3784" data-mp="281sf8pwm7swx">
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" size="small" disabled={loading} data-id="element-3785" data-mp="283d7u9zdd1s5">
                        {showPassword ? <Icon icon="lucide:eye-off" width={18} height={18} data-id="element-3786" data-mp="2m2v1p3riv58d" /> : <Icon icon="lucide:eye" width={18} height={18} data-id="element-3787" data-mp="2r04n88bsiwqx" />}
                      </IconButton>
                    </InputAdornment>
            }} sx={{
              mb: 0.5,
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#FFFFFF',
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#4F46E5',
                  borderWidth: 1.5
                }
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#4F46E5'
              }
            }} disabled={loading} data-id="element-3783" data-mp="3irx4324dypg9" />
              <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mt: 0.5,
              mb: 2
            }} data-id="element-3788" data-mp="2dxbtmyinu6bz">
                <FormControlLabel control={<Checkbox size="small" sx={{
                '&.Mui-checked': {
                  color: '#4F46E5'
                }
              }} disabled={loading} data-id="element-3790" data-mp="31md5kvqpbzm0" />} label={<Typography variant="body2" data-id="element-3791" data-mp="3l7n792jrn6jh">Remember me</Typography>} data-id="element-3789" data-mp="2noesrus14b8m" />
                <Link href="#" underline="hover" sx={{
                fontSize: '0.8rem',
                color: '#4F46E5',
                fontWeight: 500,
                transition: 'all 200ms ease',
                '&:hover': {
                  color: '#6366F1',
                  textDecoration: 'none'
                }
              }} data-id="element-3792" data-mp="36c77cgwi8gf6">
                  Forgot password?
                </Link>
              </Box>
              <Button type="submit" variant="contained" fullWidth sx={{
              py: 1.2,
              fontSize: '0.9rem',
              position: 'relative',
              overflow: 'hidden'
            }} disabled={loading} data-id="element-3793" data-mp="2skito96lxjw3">
                {loading ? 'Signing in...' : 'Sign In'}
                {loading && <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255,255,255,0.2)'
              }} data-id="element-3794" data-mp="21stsploy6oi0">
                    <Box sx={{
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  border: '3px solid rgba(255,255,255,0.3)',
                  borderTopColor: '#fff',
                  animation: 'spin 1s linear infinite',
                  '@keyframes spin': {
                    to: {
                      transform: 'rotate(360deg)'
                    }
                  }
                }} data-id="element-3795" data-mp="1iuhirxq7pald" />
                  </Box>}
              </Button>
              <Box sx={{
              textAlign: 'center',
              mt: 2
            }} data-id="element-3796" data-mp="3uh1jvtwxrizo">
                <Link href="#" underline="hover" sx={{
                fontSize: '0.8rem',
                color: '#4F46E5',
                fontWeight: 500,
                transition: 'all 200ms ease',
                '&:hover': {
                  color: '#6366F1',
                  textDecoration: 'none'
                }
              }} data-id="element-3797" data-mp="2xsdf3za8ds87">
                  Use 2FA code
                </Link>
              </Box>
            </Box>
          </CardContent>
        </Card>
        <Typography variant="body2" color="white" sx={{
        mt: 3,
        fontSize: '0.75rem',
        fontWeight: 500,
        textShadow: '0 1px 2px rgba(0,0,0,0.2)',
        position: 'relative',
        zIndex: 2
      }} data-id="element-3798" data-mp="1bnnofvt38sr">
          Powered by Paysys Labs © 2025
        </Typography>
      </Box>
    </Box>;
};
export default Login;